konnyScript(function($){
    $('[id^=\'con_swiper_slide\']').each(function(index){
        index = index+1;
        var slideScr = this.querySelector('.swiper-scrollbar');
        var slidePagination = this.querySelector('.swiper-pagination');
        var slidePrev = this.querySelector('.swiper-button-prev');
        var slideNext = this.querySelector('.swiper-button-next');
        var swiper = new Swiper(this,{
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 10,
            loop: false,
            scrollbar:{
                el:slideScr,
                hide:true,
            },
            pagination: {
                el: slidePagination,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
        });
    });
  
    $('[id^=\'con_swiper_viewmore\']').each(function(index){
        index = index+1;
        var slideScr = this.querySelector('.swiper-scrollbar');
        var slidePagination = this.querySelector('.swiper-pagination');
        var slidePrev = this.querySelector('.swiper-button-prev');
        var slideNext = this.querySelector('.swiper-button-next');
        var swiper = new Swiper(this,{
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            spaceBetween: 10,
            loop: false,
            scrollbar:{
                el:slideScr,
                hide:true,
            },
            pagination: {
                el: slidePagination,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
        });
    });
  
    var swiper = new Swiper("#srs_swiper_slide1", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
            el: '#srs_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#srs_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#srs_swiper_slide1 .swiper-button-next',
            prevEl: '#srs_swiper_slide1 .swiper-button-prev',
        },
    });

    $('[id^=\'cody_slide\']').each(function(index){
        index = index+1;
        var swiper = new Swiper(this,{
            slidesPerView: 2,
            centeredSlides:true,
            loop:true,
            speed :1500,
            autoplay:{
                delay:500,
                disableOnInteraction: false,
            },
        	loopAdditionalSlides: 0,
        });
    });

  
    var swiper = new Swiper("#estprd_swiper_slide1", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
            el: '#estprd_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#estprd_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#estprd_swiper_slide1 .swiper-button-next',
            prevEl: '#estprd_swiper_slide1 .swiper-button-prev',
        },
    });
    var swiper = new Swiper("#eprd_swiper_slide1", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        scrollbar: {
            el: '#eprd_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#eprd_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#eprd_swiper_slide1 .swiper-button-next',
            prevEl: '#eprd_swiper_slide1 .swiper-button-prev',
        },
    });
  
    var swiper = new Swiper("#w_swiper_slide1", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        scrollbar: {
            el: '#w_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#w_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#w_swiper_slide1 .swiper-button-next',
            prevEl: '#w_swiper_slide1 .swiper-button-prev',
        },
    });
  
    var swiper = new Swiper("#w_swiper_slide2", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        scrollbar: {
            el: '#w_swiper_slide2 .swiper-scrollbar',
        },
        pagination: {
            el: '#w_swiper_slide2 .swiper-pagination',
        },
        navigation: {
            nextEl: '#w_swiper_slide2 .swiper-button-next',
            prevEl: '#w_swiper_slide2 .swiper-button-prev',
        },
    });
  
    var swiper = new Swiper("#w_swiper_slide3", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        scrollbar: {
            el: '#w_swiper_slide3 .swiper-scrollbar',
        },
        pagination: {
            el: '#w_swiper_slide3 .swiper-pagination',
        },
        navigation: {
            nextEl: '#w_swiper_slide3 .swiper-button-next',
            prevEl: '#w_swiper_slide3 .swiper-button-prev',
        },
    });


  
    /* 이스터프로모션 슬라이드 */
    var swiper = new Swiper("#est_prd_swiper_slide1", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        scrollbar: {
            el: '#est_prd_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#est_prd_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#est_prd_swiper_slide1 .swiper-button-next',
            prevEl: '#est_prd_swiper_slide1 .swiper-button-prev',
        },
    });
  
    var swiper = new Swiper("#est_prd_swiper_slide2", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        scrollbar: {
            el: '#est_prd_swiper_slide2 .swiper-scrollbar',
        },
        pagination: {
            el: '#est_prd_swiper_slide2 .swiper-pagination',
        },
        navigation: {
            nextEl: '#est_prd_swiper_slide2 .swiper-button-next',
            prevEl: '#est_prd_swiper_slide2 .swiper-button-prev',
        },
    });
  
    var swiper = new Swiper("#est_prd_swiper_slide3", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        scrollbar: {
            el: '#est_prd_swiper_slide3 .swiper-scrollbar',
        },
        pagination: {
            el: '#est_prd_swiper_slide3 .swiper-pagination',
        },
        navigation: {
            nextEl: '#est_prd_swiper_slide3 .swiper-button-next',
            prevEl: '#est_prd_swiper_slide3 .swiper-button-prev',
        },
    });

});